// extracted by mini-css-extract-plugin
export default {"fullWidth":"bo-z","image":"co-z","lazyLoadPicture":"do-z","lazyLoadSpinner":"eo-z","lazyLoadSpin":"fo-z","lazyLoadImage":"go-z","hasStyledAspectRatio":"ho-z"};